import React from 'react';

import FiltersApptStatusContent from './FiltersApptStatusContent';

import { APPOINTMENT_STATUS } from './contants';

const FiltersAppointmentStatus: React.FC = () => (
  <FiltersApptStatusContent type="apptStatus" items={APPOINTMENT_STATUS} />
);
export default FiltersAppointmentStatus;
